import { render, staticRenderFns } from "./bindPhone.vue?vue&type=template&id=6f22430a&"
import script from "./bindPhone.vue?vue&type=script&lang=js&"
export * from "./bindPhone.vue?vue&type=script&lang=js&"
import style0 from "./bindPhone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports